export enum PaymentTypeEnum {
  PREPAID = 'PREPAID',
  PAY_LATER = 'PAY LATER',
  cards = 'cards',
  apm = 'apm',
  local_bank_transfer = 'local_bank_transfer',
  wire_transfer = 'wire_transfer',
  GET_PAID = 'GET_PAID',
}
